/**
 * Single source of truth for "is this a real, funded loan yet?" on the FE.
 */
export const FUNDED_STATUSES = Object.freeze([
    'current',
    'past_due',
    'collection',
    'legal',
    'legal_processed',
    'legal_not_processed',
    'paused',
    'pay_in_full_processing',
    'pay_in_full_posted',
    'closed',
    'closed_remarketable',
]);

/**
 * @param {{status?: string}|null|undefined} loan
 * @returns {boolean}
 */
export const isFunded = (loan) => FUNDED_STATUSES.includes(loan?.status);
